import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import style from './image.scss';
import { Spinner } from '.';

const DOWNLOADED_IMAGES = {};

@CSSModules(style, { allowMultiple: true })
export default class Image extends Component {
  state = {
    downloading: false
  };

  constructor(props) {
    super(props);
    this.download = this.download.bind(this, this.props);
  }

  download(props) {
    if (DOWNLOADED_IMAGES[props.source] || !this.props.source) return;
    this.setState({ downloading: true })
    const image = new window.Image();
    image.onload = () => {
      this.setState({ downloading: false });
      DOWNLOADED_IMAGES[props.source] = true;
    }
    image.onerror = () => {
      this.setState({ downloading: false });
    }
    image.src = props.source;
  }

  render() {
    const rootStyle = ['root'];
    const { downloading } = this.state;
    const { circle, cover, square, source, width, hideOnLoad } = this.props;

    if (circle) rootStyle.push('circle');
    if (cover) rootStyle.push('cover');
    if (square) rootStyle.push('square');

    const style = {
      backgroundImage: hideOnLoad && downloading ? null : `url('${this.props.source}')`,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }

    return (
      <div className="Image" styleName={rootStyle.join(' ')}>
        <div styleName="image" style={style} />
        <img src={source} width={width} />
        {downloading ? (
          <div styleName="spinner-wrapper">
            <Spinner />
          </div>
        ) : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/image.js